const url = 'https://aq5u85j9s7.execute-api.us-east-1.amazonaws.com/prod';
// const url = 'http://localhost:3000'

export { url };